import Container from 'react-bootstrap/Container';
import React, { useContext, useReducer, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Store } from '../../Store';
import { Helmet } from 'react-helmet-async';
import { toast } from 'react-toastify';
import { getError } from '../../utils';
import { useTranslation } from 'react-i18next';
import authService from '../../services/auth.service';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_SUCCESS':
      return { ...state, product: action.payload, loading: false };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default function VerifyUser() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { token } = useParams();
  const { /*state,*/ dispatch: ctxDispatch } = useContext(Store);
  const [{ loading, error }, dispatch] = useReducer(reducer, {
    loading: true,
    error: '',
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch({ type: 'FETCH_REQUEST' });
        const data = await authService.verifyUser(token);
        dispatch({ type: 'FETCH_SUCCESS', payload: data });
        ctxDispatch({ type: 'USER_SIGNIN', payload: data });
        localStorage.setItem('userInfo', JSON.stringify(data));
        navigate('/');
        toast.success(t('auth.verificationSuccess'));
      } catch (err) {
        dispatch({ type: 'FETCH_FAIL', payload: getError(err) });
        toast.error(getError(err));
      }
    };
    fetchData();
  }, [token, navigate, ctxDispatch, t]);

  return (
    <Container className='small-container'>
      <Helmet>
        <title>{t('auth.verifyUser')}</title>
      </Helmet>
      <h1 className='my-3'>{t('auth.verifyUser')}</h1>
      {loading ? (
        <div>{t('common.loading')}...</div>
      ) : error ? (
        <div className='danger'>{error}</div>
      ) : (
        <div className='success'>{t('auth.verificationSuccess')}</div>
      )}
    </Container>
  );
}
